// src/v2/services/reportsService.js
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const reportsService = {
  getReportData: async (reportType, filters) => {
    const res = await axios.get(`${domain}/api/Reports/${reportType}`, {
      params: filters,
      headers
    });
    return res.data;
  },

  // MODIFIED: Uses Query Params for BIR1601C
  getBIR1601C: async (queryParams) => {
    const res = await axios.get(`${domain}/api/Reports/BIR1601C`, {
      params: queryParams, // This sends ?companyId=X&month=Y&year=Z
      headers
    });
    return res.data;
  },
};

export default reportsService;